import parseMap from '../../scripts/parseMap.mjs'
import readProject from '../readProject.mjs'

export default mapData => {
    return async () => {
        const initData = parseMap(mapData)
        const project = await readProject(initData.data.prjId)
        Object.assign(initData.data, project)
        return initData
    }
}
